export const FETCHED_TRANSLATIONS = 'FETCHED_TRANSLATIONS'
export const FETCHING_TRANSLATIONS = 'FETCHING_TRANSLATIONS'
export const CHANGE_LANGUGAGE = 'CHANGE_LANGUGAGE'

export function translations(
  translations={
    isFetching: true,
    data: {},
    lang: 'en',
  },
  action,
) {
  switch (action.type) {
    case FETCHING_TRANSLATIONS:
      return {
        ...translations,
        isFetching: true,
      }
    case FETCHED_TRANSLATIONS:
      return {
        ...translations,
        isFetching: false,
        data: action.translations,
      }
    case CHANGE_LANGUGAGE:
      return {
        ...translations,
        lang: action.lang,
      }
    default:
      return translations
  }
}
